import { addPoints, reducePoints } from "../../http/patientAPI";

export const handleClick = (id, points, type, comment, handleClose, handleUpdatePoints) => {
    if (!isNaN(points)) {
      if(type === 'addPoints'){
        addPoints(id, points, comment)
        .then(response => {
          handleClose();
          if (handleUpdatePoints) {
            handleUpdatePoints(points, 'add');
          }
        })
        .catch(error => {
          console.error('Ошибка при начислении баллов:', error);
        });
      };
     if (type === 'reducePoints') {
      reducePoints(id, points, comment)
        .then(response => {
          handleClose();
          if (handleUpdatePoints) {
            handleUpdatePoints(points, 'reduce');
          }
        })
        .catch(error => {
          console.error('Ошибка при списании баллов:', error);
        });
     }
    } else {
      console.error('Введите корректное количество баллов');
    }
  };